import { string, object } from 'yup';

const schema = object().shape({
  name: string().required('requiredField')
});

export default schema;